import { Divider } from "antd";
import { CreditCard } from "lucide-react";
import React from "react";

const PayCard = ({employee}) => {
  return (
    <div className="w-full rounded-lg border-2 border-form-bg border-t-[#231564] shadow-lg px-2 sm:px-3 py-2 sm:py-3 bg-white">
      {/* Header */}
      <div className="flex items-center gap-2 text-black font-semibold">
        <CreditCard size={18} sm:size={20} className="text-gray-400" />
        <h2 className="text-sm sm:text-md font-bold">Payment Details</h2>
      </div>
      <Divider className="!p-0 !m-0" />

      {/* Grid Layout for Payment Details */}
      <div className="grid grid-cols-2 gap-y-2 sm:gap-y-3 text-sm sm:text-md mt-2">
        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">PAYMENT METHOD</span>
        <span className="whitespace-nowrap capitalize">{employee?.payment_type || 'N/A'}</span>

        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">BANK NAME</span>
        <span className="whitespace-nowrap capitalize">{employee?.bank_name || 'N/A'}</span>

        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">Account Title</span>
        <span className="whitespace-nowrap capitalize">{employee?.account_title || 'N/A'}</span>

        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">ACCOUNT NO  </span>
        <span className="whitespace-nowrap capitalize">
          {employee?.account_number || 'N/A'}
        </span>
        <span className="text-gray-400 text-sm sm:text-md whitespace-nowrap">IBAN NUMBER </span>
        <span className="whitespace-nowrap capitalize">
          {employee?.account_number || 'N/A'}
        </span>
      </div>
    </div>
  );
};

export default PayCard;
